// extracted by mini-css-extract-plugin
export default {"button":"btnStyle_button__mSf78","button2":"btnStyle_button2__Zv6It"};